import { Grid, useTheme } from "@mui/material";
import React from "react";
import { Base } from ".";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

interface Props {
  title: string;
}

const TitleBar: React.FC<Props> = (props) => {
  const { title } = props;
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Grid
      container
      sx={{
        py: 1,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        display: { xs: "flex", sm: "none" },
      }}
      direction={"row"}
      alignItems={"center"}
    >
      <Base.IconButton
        icon={<ArrowBack />}
        label=""
        onClick={() => navigate(-1)}
      />
      <Grid flex={1}>
        <Base.Text text={title} center variant="h3" />
      </Grid>
    </Grid>
  );
};

export default TitleBar;
